import React, {Component} from 'react';
import "./AdminChat.css";
import axios from "axios";
import {RESOURCE_BASE_URL, WS_BASE_URL} from "../../../configuration";
import {FormattedMessage} from "react-intl";
import {addResponseMessage} from "react-chat-popup";
import InitialAdminState from '../../Admin/AdminRoot/InitialAdminState'

let userNames = [];
let userNamesTemp = [];
let stompClient = null;
let userNameCount = 1;
let previousChatButtonId = "";
let currentChatButtonId = "";

class AdminChat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chatMessage: "",
            chats: [],
            chatMap: Map,
            userIndexMap: Map,
            newMessageCountMap: Map,
            userToAdminMap: Map,
            chatUserCount: 0,
            isStompClientConnected: false,
            intervalId: -1,
            inChatWith: null,
            userNames: [],
            userNamesTemp: [],
            elementUserName: "",
            clickedUserName: "",
            unknownUserCount: 0,
            closeBtn: false,
            disableAdminChat: true,
            loggedUserName: ''
        };


        this.sendChat = this.sendChat.bind(this);
        this.getAllPendingCHatRequests = this.getAllPendingCHatRequests.bind(this);
        this.setChatMessage = this.setChatMessage.bind(this);
        this.getUserName = this.getUserName.bind(this);
        this.getUserData = this.getUserData.bind(this);
        this.userDivOnload = this.userDivOnload.bind(this);
        this.removeDuplicates = this.removeDuplicates.bind(this);
        this.removeDupUsers = this.removeDupUsers.bind(this);
        this.loadChatMessages = this.loadChatMessages.bind(this);
        this.disableUserDiv = this.disableUserDiv.bind(this);
        this.convertDateTime = this.convertDateTime.bind(this);
        this.removeOfflineChatUsers = this.removeOfflineChatUsers.bind(this);
        this.state.userName = "ADMIN-ID-001";
        this.connect(this.state.userName);

        this.callMulFunctions = this.callMulFunctions.bind(this);
        this.closeChat = this.closeChat.bind();
        this.pressEnterKey = this.pressEnterKey.bind();
        this.timeConverter = this.timeConverter.bind();
        this.onMessageReceived = this.onMessageReceived.bind();
    }


    connect = (userName) => {
        if (userName && !this.state.isStompClientConnected) {
            this.setState({
                username: userName
            });
            const Stomp = require('stompjs');
            var SockJS = require('sockjs-client');
            SockJS = new SockJS(WS_BASE_URL + "ws");
            stompClient = Stomp.over(SockJS);
            stompClient.connect({}, this.onConnected, this.onError);
        }
    };


    timeConverter = (time) => {
        let conTime = time.slice(0, 4) + " 年 " + time.slice(5, 7) + " 月 " + time.slice(8, 10) + " 日 " + time.slice(11, 13) + " 時 " + time.slice(14, 16) + " 分";

        return conTime;
    }
    removeDuplicates = (arr, comp) => {

        const unique = arr
            .map(e => e[comp])

            // store the keys of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the dead keys & store unique objects
            .filter(e => arr[e]).map(e => arr[e]);
        return unique;


        // let result = this.removeDupUsers();
        // return result;

    };

    removeDupUsers = () => {

        userNames.map((user) => {

            //console.log("user name list------------------*************************---------------------------  ", user);
            if (userNamesTemp.length > 0) {
                userNamesTemp.map((tempUser) => {
                    if (tempUser.length === 0) {
                        // userNamesTemp.push({id: user.id, name: user.name});
                    }
                })
            } else {
                // userNamesTemp.push({id: user.id, name: user.name});
            }
        })

        // userNames = userNamesTemp

        return userNames;

    }

    onConnected = () => {

        this.setState({
            isStompClientConnected: true
        });
        clearInterval(this.state.intervalId);

        // Subscribing to chat
        stompClient.subscribe('/kitcut/chat', this.onMessageReceived);
        // Registering user to server
        stompClient.send("/app/addUser/admin",
            {},
            JSON.stringify({sender: this.state.userName, type: 'JOIN'})
        );

        this.props.getAllPendingChats();
    };

    callMulFunctions = (chatUserId) => {
        // this.getUserName(chatUserId);
        // this.userDivOnload(chatUserId);
        userNames.map((user) => {
            if (user.id === chatUserId) {
                console.log("userId ==>", user);

                this.getUserName(chatUserId);

                document.getElementsByClassName(chatUserId).innerText = user.name;

            }
        })


    }

    onError = (error) => {
        //console.log("error occurred while connecting to ws" + error);

        if (this.state.intervalId !== -1) {
            clearInterval(this.state.intervalId);
        }
        let intervalId = setInterval(() => {
            this.connect(this.state.userName)
        }, 5000);
        this.setState({intervalId: intervalId});
    };


    sendMessage = (type, value, receiver) => {
        //console.log("Sending message");
        let userName = this.state.userName;
        if (stompClient && this.state.isStompClientConnected) {
            var chatMessage = {
                sender: this.props.userId,
                receiver: receiver,
                content: value,
                type: type,
                inChatWithAdmin: true
            };
            stompClient.send("/app/sendMessage", {}, JSON.stringify(chatMessage));
        } else {
            //console.log("client is null or not connected");
            this.connect(userName);
        }
    };

    onMessageReceived = () => {
        this.getAllPendingCHatRequests();
        this.props.getAllPendingChats();

        setTimeout(()=>{
            this.getAllPendingCHatRequests();
        },1500)

    };

    handleNewUserMessage = () => {
        //console.log(`New message incoming! ${this.state.chatMessage}`);
        if (this.state.chatMessage !== "") {
            this.sendMessage('ADMIN_REPLY', this.state.chatMessage, this.state.inChatWith);

        }
        // this.sendMessage('ADMIN_REPLY', this.state.chatMessage, this.state.inChatWith);

        this.setState({
            chatMessage: ""
        })

    };

    getAllPendingCHatRequests() {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/admin/pending', axiosConfig)
            .then((res) => {
                console.log("CHAT-DATA", res.data);
                this.setState({
                    chatMap: res.data.userMessagesMap,
                    userIndexMap: res.data.userIndexMap,
                    newMessageCountMap: res.data.newMessageCountMap,
                    userToAdminMap: res.data.userToAdminMap,
                    chatUserCount: res.data.onlineUsers
                }, () => this.disableUserDiv());
                this.chatBox.value = "";
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    }


    getUserName(userId) {
        console.log("trying to get userName ===> ", userId);
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + userId, axiosConfig)
            .then((res) => {
                // console.log("User-Data", res.data);
                userNames.push({id: res.data.id, name: res.data.japaneseLastName + " "+ res.data.japaneseFirstName});
                userNames = this.removeDuplicates(userNames, {id: res.data.id, name: res.data.japaneseLastName + " "+ res.data.japaneseFirstName});
                // userNames = names;
                // return res.data.name;
            })
            .catch((err) => {
                //console.log("[API] ERROR: ", err);
            });
    }

    getUserData(userId) {
        let isAlreadyExist = false;

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + userId, axiosConfig)
            .then((res) => {
                // console.log("getUserData ---------------------------------------------------------------------------%%%  ", res.data.name);
                if (userNamesTemp.length === 0) {
                    // userNamesTemp.push({id:res.data.id,name:res.data.name})
                    isAlreadyExist = false;
                } else {
                    userNamesTemp.map((user) => {
                        // console.log("getUserData if condition checking -----------------------------------------------%%%  ", user.id,res.data.id);

                        if (user.id === res.data.id) {
                            // console.log("inside if condition ////////////////////  ", user.id,res.data.id)
                            // userNamesTemp.push({id:res.data.id,name:res.data.name})
                            isAlreadyExist = true;
                        }
                    })
                }

                if (!isAlreadyExist) {
                    userNamesTemp.push({id: res.data.id, name: res.data.japaneseLastName + " "+ res.data.japaneseFirstName})

                }
                // console.log("userNamesTemp.length ---------------------------------------------------------------------------%%%  ", userNamesTemp.length);
                // console.log("userNamesTemp---------------------------------------------------------------------------%%%  ", userNamesTemp);
                // userNames.push({id: res.data.id, name: res.data.name});
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    }


    removeOfflineChatUsers = (userId) => {

        //console.log("REMOVE OFFLINE USER KEY ===> ", userId);

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/chat/user/remove/' + userId, axiosConfig)
            .then((res) => {
                //console.log("REMOVE USER FROM CHAT ====> ", res.data);
            })
            .catch((err) => {
                //console.log("REMOVE USER FROM FAILED ====> ");
                //console.log("[API] ERROR: ", err);
            });
    };

    componentDidMount() {
        InitialAdminState.userCountId = 0;
        // let intervalId = setInterval(this.getAllPendingCHatRequests, 2000);
        // this.setState({intervalId: intervalId});
        this.getAllPendingCHatRequests();
        userNameCount = 1;

        let offlineUserId = this.props.offlineUserId;
        //console.log("REMOVE OFFLINE USER KEY ===> ", offlineUserId);
        if (offlineUserId !== null) {
            this.removeOfflineChatUsers(offlineUserId);
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        InitialAdminState.userCountId = 0;

//        this.bottomFix.scrollIntoView({behavior: "smooth"});
        this.messagesEnd.scrollIntoView({behavior: "smooth"});
        let offlineUserId = this.props.offlineUserId;
        //console.log("REMOVE OFFLINE USER KEY ===> ", offlineUserId);
        // if(offlineUserId !== null){
        //     this.removeOfflineChatUsers(offlineUserId);
        // }

        this.removeDupUsers();

    }

    getUpdate = () => {
        //console.log("Fetching...");

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/chat', axiosConfig)
            .then((res) => {
                this.setState({
                    chats: res.data
                });
                //console.log("Fetched:", res.data);
            })
            .catch((err) => {
                //console.log("[API] ERROR: ", err);
            });
    };

    setChatMessage = (e) => {
        this.setState({chatMessage: e.target.value});
    };


    loadChatMessages = (userId) => {
        console.log("inside of the loadChat ===> ", userId);

        this.setState({
            clickedUserName: userId,
            closeBtn: true,
            disableAdminChat: false
        })

        this.getUserData(userId);
        userNamesTemp.map((user) => {
            if (user.id === userId) {
                this.setState({
                    clickedUserName: user.name
                })
            } else {
                // this.setState({
                //     clickedUserName: userId
                // })
            }
        });
        previousChatButtonId = currentChatButtonId;
        currentChatButtonId = "user-" + userId;
        if (previousChatButtonId != "") {
            if (document.getElementById(previousChatButtonId) != null)
                document.getElementById(previousChatButtonId).className = "user-div";
        }
        if (document.getElementById(currentChatButtonId) != null)
            document.getElementById(currentChatButtonId).className = "active-chat";

        // //console.log("clicked chat user name ======================================= ",userId )
        //console.log(this.state.chatMap[userId]);
        this.setState({
            inChatWith: userId
        });
    };

    sendChat = () => {
        //console.log(this.state.chatMessage);
        if (this.state.chatMessage === "") return;

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        let chat = {
            message: this.state.chatMessage,
            createdBy: "2"
        };
        axios.post(RESOURCE_BASE_URL + 'api/chat', chat, axiosConfig)
            .then((res) => {
                //console.log("DATA", res.data);
                this.setState({
                    chatMessage: ""
                });
                this.chatBox.value = "";
            })
            .catch((err) => {
                //console.log("[API] ERROR: ", err);
            });
    };

    userDivOnload = (userId) => {
        // console.log("user id ***************************************************************user id  ", userId)
        // InitialAdminState.userCountId=0;
        // var userCountId = 0;
        InitialAdminState.userCountId++;
        // this.getUserName(userId);
        this.getUserData(userId);
        // console.log("inside userDivOnLoad ===========>>>>>>>>>  ", userNamesTemp)
        userNamesTemp.map((userTem) => {
            if (userTem.id === userId) {

                // document.getElementsById(userId).innerText = user.name;
                let x = document.getElementsByClassName(userId).length;
                if (x > 0) {
                    // console.log("inside userDevOnLoad==================username==============  ", userTem.name)
                    document.getElementsByClassName(userId)[0].innerHTML = userTem.name;
                    console.log("user tempory ===>", userTem);
                }
            } else {
                let x = document.getElementsByClassName(userId).length;
                if (x > 0) {
                    // document.getElementsByClassName(userId)[0].innerHTML = "お客様  " + InitialAdminState.userCountId;
                }
            }
        })


    };

    isInChatWithAnotherAdmin = (chatUserId) => {
//        if (this.state.chatMap[chatUserId][this.state.chatMap[chatUserId].length - 1].inChatWithAdmin) {
//            var sender = this.state.chatMap[chatUserId][this.state.chatMap[chatUserId].length - 1].sender;
//            var receiver = this.state.chatMap[chatUserId][this.state.chatMap[chatUserId].length - 1].receiver;
//            if(sender === this.props.userId || receiver === this.props.userId)
//            {
//                return false;
//            }
//            return true;
//        }
        if (this.state.userToAdminMap[chatUserId] === this.props.userId || this.state.userToAdminMap[chatUserId] === "ADMIN-ANY") {
            return false;
        }
        return true;
    }

    closeChat = () => {

        this.setState({
            inChatWith: null,
            clickedUserName: null,
            closeBtn: false,
            disableAdminChat: true
        })
    };

    pressEnterKey = (event) => {

        // if(event.keyCode===13){
        //     this.handleNewUserMessage();
        // }


        this.handleNewUserMessage();

    };
    convertDateTime = (date) => {
        let d = new Date(Date.parse(date));

        let sentDate = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate() + " @ " + d.getHours() + ":" + d.getMinutes();

        //console.log("DATEEEEEE =====> ", sentDate);

        return sentDate;

    };

    disableUserDiv = () => {

        // Object.keys(this.state.chatMap).map((chatUserId) => {
        //         this.state.chatMap[chatUserId].map((item) => {
        //
        //             if(item.receiver !== this.props.userId){
        //                 let userNameDiv = document.getElementById("user-"+chatUserId);
        //                 userNameDiv.classList.add("disabled");
        //                 // userNameDiv.setAttribute("disabled", "{true}");
        //                 // //console.log("USER ON CHAT ================================================", userNameDiv.classList);
        //                 return true;
        //             }
        //             else {
        //                 return false;
        //             }
        //         });
        // }
        //
        // );

    };

    render() {

        //console.log("USERNAMES RENDER====>", userNames);
        //console.log("CHAT MAPPPPPP =====> ", this.state.chatMap);
        //console.log("IN CHAT WITH =====> ", this.state.inChatWith);


        let fullwidth = {width: "100%"};
        //console.log(this.state.chatMessage);

        let chatUserCount = 0;
        return (
            <div className="row">
                <div className="div-center">
                    <h3 className="chat-heading">チャット一覧</h3>

                </div>

                <div className="responsive-chat-close-btn">
                    <div className="col-md-3">

                    </div>
                    <div className="col-md-9">

                        {this.state.closeBtn ? <div className="left-close-btn">
                                <button type="button" className="close" aria-label="Close" onClick={() => this.closeChat()}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            :
                            ""
                        }
                        {/*<div className="left-close-btn">*/}
                        {/*<button type="button" className="close" aria-label="Close" onClick={() => this.closeChat()}>*/}
                        {/*<span aria-hidden="true">&times;</span>*/}
                        {/*</button>*/}
                        {/*</div>*/}
                    </div>
                </div>

                <div className="margin-left-remove-chat">
                    <div className="col-md-3 chat-users-scroll div-top-margin">

                        <div className="users-list">
                            <div className="float-name"><b>ユーザー一覧</b></div>
                            <br/>
                            {


                                Object.keys(this.state.userIndexMap).map((chatUserId) => {


                                    console.log('this.state.chatMap -------------------------------->>>>>>>>>>> ', this.state.chatMap);
                                    console.log('this.state.chatMap -------------------------------->>>>>>>>>>> ', this.state.userIndexMap);
                                    //console.log('user id -------------------------------->>>>>>>>>>> ', chatUserId);
                                    // //console.log("this is the logged admin user ID ================================>>>>>>>>>>",this.props.userId );
                                    chatUserCount++;
                                    // //console.log("chat user count ----------------------------->>>>> ",chatUserCount);
                                    //
                                    // //console.log("message list======================>", this.state.chatMap[chatUserId]);


                                    let isAdminChat = true;
                                    console.log("---------------->> adminchat.js chatuserId:" + chatUserId);
                                    for (let i = 0; i < this.state.chatMap[chatUserId].length; i++) {

                                        if (this.state.chatMap[chatUserId][i].inChatWithAdmin) {
                                            isAdminChat = false;

                                            if (this.props.userId === this.state.chatMap[chatUserId][i].sender || this.props.userId === this.state.chatMap[chatUserId][i].receiver) {
                                                isAdminChat = true;
                                            }
                                        }

                                    }

                                    let loggedUserName = '';
                                    var checkUserName = chatUserId.split("-");
                                    let usrNameString = checkUserName[0];


                                    if (usrNameString === 'random') {
                                            loggedUserName = "お客様" + (this.state.userIndexMap[chatUserId]);

                                        // loggedUser.style.display = 'none';
                                        // randomUser.style.display = 'block';
                                    } else {
                                            loggedUserName = chatUserId

                                        // loggedUser.style.display = 'block';
                                        // randomUser.style.display = 'none';
                                    }



                                    // this.state.chatMap[chatUserId].map((item) => {
                                    //     if(item.sender === this.props.userId){
                                    //         this.disableUserDiv(chatUserId);
                                    //     }
                                    // });


                                    if (isAdminChat) {

                                        return (
                                            <button className="btn btn-default user-div" id={"user-" + chatUserId}
                                                    disabled={this.isInChatWithAnotherAdmin(chatUserId)}
                                                    onClick={() => this.loadChatMessages(chatUserId)}>

                                                {/*<div className="col-md-6" id={chatUserId} onLoad={this.getUserName(chatUserId)}>*/}
                                                <div className="responsive-chat-users-row">
                                                    <div id = "random_user" className={"col-md-11 remove-padding-chat " + chatUserId}
                                                         onLoad={this.getUserName(chatUserId)}>
                                                        {/*<div className="col-md-6" id={chatUserId} onLoad={this.callMulFunctions(chatUserId)}>*/}
                                                        {/*<div className="col-md-6" id={chatUserId} onClick={() => this.callMulFunctions(chatUserId)}>*/}
                                                        {/*<div className="col-md-6" id={chatUserId} onLoad={this.callMulFunctions(chatUserId)}>*/}
                                                        {/*<span id="username">{"お客様"}{this.userDivOnload(chatUserId)}</span>*/}
                                                        <div>
                                                            {this.userDivOnload(chatUserId)}<span>{loggedUserName}</span>
                                                        </div>
                                                        {/*<div>*/}
                                                        {/*    {this.userDivOnload(chatUserId)}<span>{"お客様" + (this.state.userIndexMap[chatUserId])}</span>*/}
                                                        {/*</div>*/}
                                                        {/*<span id="username">{"お客様"}{this.userDivOnload(chatUserId)}</span>*/}
                                                        {/*<span id="username">{"お客様"}{this.state.elementUserName}</span>*/}
                                                        {/*<span id="username">{"お客様"}{chatUserId}</span>*/}
                                                        {/*<div id={chatUserId} onLoad={this.userDivOnload(chatUserId)}>{"お客様"}{this.state.elementUserName}</div>*/}
                                                    </div>
                                                </div>

                                                {this.state.chatMap[chatUserId].length !== 0 ?
                                                    <div className="col-md-1 text-right remove-padding-chat">
                                                <span className="badge chat-count-badge">
                                                    {this.state.newMessageCountMap[chatUserId]}
                                                </span></div> : ""}

                                            </button>
                                        );
                                    }


                                    //
                                    // return (
                                    //     <button className="btn btn-default user-div" id={"user-"+chatUserId}
                                    //          onClick={() => this.loadChatMessages(chatUserId)}>
                                    //
                                    //                     <div className="col-md-6" id={chatUserId} onLoad={()=>this.getUserName(chatUserId)}>
                                    //                         <span id="username">{"お客様"}{this.userDivOnload(chatUserId)}</span>
                                    //                     </div>
                                    //                     {this.state.chatMap[chatUserId].length !== 0 ?
                                    //                         <div className="col-md-6 text-right">
                                    //             <span className="badge chat-count-badge">
                                    //                 {this.state.chatMap[chatUserId].length}
                                    //             </span></div> : ""}
                                    //
                                    //     </button>
                                    // );

                                })}
                        </div>
                    </div>
                    <div className="col-md-9 div-top-margin">
                        <div className="admin-chat-container">
                            <div className="admin-chat-top" ref={(el) => {
                                this.messagesEnd = el;
                            }}>
                                {/*<div className="user-name-div">{this.state.clickedUserName}</div>*/}


                                {/*{this.state.chats.map((c) => {*/}
                                {/*    let className = (c.createdBy === "1") ?*/}
                                {/*        "admin-chat-message admin-chat-user-2" : "admin-chat-message admin-chat-user-1";*/}
                                {/*    return (*/}
                                {/*        <div className={className}>*/}
                                {/*            {c.message}*/}
                                {/*        </div>*/}
                                {/*    )*/}
                                {/*})}*/}


                                {/*<div className="bottom-fix" ref={(el) => {
                                    this.bottomFix = el;
                                }}></div>*/}

                                {this.state.chatMap[this.state.inChatWith] && this.state.inChatWith !== null && !this.isInChatWithAnotherAdmin(this.state.inChatWith) &&
                                <div>
                                    {
                                        this.state.chatMap[this.state.inChatWith].map((item) => {

                                            // {
                                            //     this.timeConverter(item.dateTime)
                                            // }


                                            if (item.sender === this.props.userId) {
                                                return (
                                                    <div className="col-md-12 no-padding">
                                                        <div className="col-md-6">&nbsp;</div>
                                                        <div className="col-md-6  no-padding">
                                                            <div className="admin-chat-message-div">
                                                                <div className='text-area-content'>{item.content}</div>
                                                                <br/>
                                                                {/*<div className="chat-date-time text-right">*/}
                                                                {/*    <small>{this.timeConverter(item.dateTime)}</small>*/}
                                                                {/*</div>*/}
                                                            </div>
                                                        </div>

                                                    </div>
                                                );
                                            } else {
                                                return (
                                                    <div className="col-md-12 no-padding">
                                                        <div className="col-md-6 no-padding">
                                                            <div className="user-chat-message-div">
                                                                <div
                                                                    className='chat-content-overflow'>{item.content}</div>
                                                                <br/>
                                                                {/*<div className="chat-date-time text-right">*/}
                                                                {/*    <small>{this.timeConverter(item.dateTime)}</small>*/}
                                                                {/*</div>*/}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">&nbsp;</div>

                                                    </div>
                                                );
                                            }

                                            // return (<div>
                                            //     <span>{item.sender} : {item.dateTime} </span>
                                            //     <span>{item.content} :</span>
                                            // </div>)

                                        })
                                    }
                                </div>

                                }
                            </div>
                            <div className="admin-chat-bottom">
                                <div>
                                    <textarea
                                        disabled={this.state.disableAdminChat}
                                        onChange={this.setChatMessage}
                                        // onKeyUp={(event) => this.pressEnterKey(event)} style={fullwidth}
                                        style={fullwidth}
                                        rows={5}
                                        ref={(el) => {
                                            this.chatBox = el;
                                        }}
                                        onKeyPress={(ev) => {
                                            if (ev.key === 'Enter') {
                                                ev.preventDefault();
                                                document.getElementById("chat-buttton").click();
                                            }
                                        }}>
                            {this.state.chatMessage}
                        </textarea>
                                </div>
                                <div>
                                    <button onClick={this.handleNewUserMessage}
                                            className="btn btn-primary admin-send-button"
                                            id="chat-buttton">
                                        送信
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AdminChat;



// WEBPACK FOOTER //
// ./src/components/Admin/AdminChat/AdminChat.js